import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <div className="header-glass sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center gap-4">
          <Link to="/register" className="btn-ghost flex items-center gap-1 text-sm" data-testid="back-to-register">
            <ArrowLeft size={18} /> Back
          </Link>
          <span className="text-lg brand-name text-[#007AFF]">Zelvrix</span>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <iframe
          src="https://app.termly.io/policy-viewer/policy.html?policyUUID=61ba238e-58ad-4aa6-8dc3-32d49e729dfa"
          title="Terms and Conditions"
          className="w-full border-0 rounded-2xl bg-white"
          style={{ minHeight: 'calc(100vh - 120px)' }}
          data-testid="terms-iframe"
        />
      </div>
    </div>
  );
}
